import type { AxiosError } from 'axios';

import { isAxiosError } from './errors';
import { FetchError } from './types';

/**
 * Determines if a react-query error comes from an HTTP error response with a particular HTTP status code
 * @param error The error to query
 * @param status The HTTP status code to check
 * @returns true if the error comes from an HTTP error response and has the appropriate status code
 */
export function isErrorWithStatus<ErrorBody = unknown>(
  error: FetchError<ErrorBody> | null | undefined,
  status: number
): error is AxiosError<ErrorBody>;
export function isErrorWithStatus(error: unknown, status: number): boolean;
export function isErrorWithStatus(error: unknown, status: number): boolean {
  return !!error && isAxiosError(error) && error.response?.status === status;
}
